import * as React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";
import { isMobileScreen } from "../../../lib/utils";
import { generateTimeSlots } from "../../../lib/utils";
import { Dialog, DialogContent, DialogTrigger } from "./dialog";
import { ScrollArea } from "./scroll-area";
import { RiArrowDropDownLine } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";

interface TimeSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function TimeSelect({ value, onChange, className }: TimeSelectProps) {
  const timeSlots = React.useMemo(() => generateTimeSlots(15), []);
  const [isOpen, setIsOpen] = React.useState(false);

  if (isMobileScreen) {
    return (
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogTrigger
          className={`flex items-center justify-between border rounded-lg py-2 px-3 ${className}`}
        >
          <span>{value}</span>
          <RiArrowDropDownLine className="h-6 w-6" />
        </DialogTrigger>
        <DialogContent className="w-full max-w-full sm:max-w-md p-0 h-[90vh] flex flex-col">
          <div className="sticky top-0 z-10 bg-white p-4 border-b flex items-center justify-between">
            <span className="text-lg font-medium">Select Time</span>
            <button
              className="p-2 rounded-full hover:bg-gray-100"
              onClick={() => setIsOpen(false)}
            >
              <IoMdClose className="h-6 w-6" />
            </button>
          </div>
          <ScrollArea className="flex-1">
            <div className="p-4">
              {timeSlots.map((time) => (
                <div
                  key={time}
                  className="p-3 cursor-pointer hover:bg-gray-100 text-gray-700 border-b last:border-b-0"
                  onClick={() => {
                    onChange(time);
                    setIsOpen(false);
                  }}
                >
                  {time}
                </div>
              ))}
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue>{value}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup className="max-h-[300px] overflow-auto">
          {timeSlots.map((time) => (
            <SelectItem key={time} value={time}>
              {time}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
